import $ from 'jquery';
import startTimer from './Timer';
import { initTurboForm } from '../lib/TurboForm';

$('.js-form[name="send_code"]').on('turboForm:response', function(e) {
    const form = $(e.target);
    const response = JSON.parse(e.detail.response);

    if (form.attr('name') !== 'send_code') {
        makeReadonlyPhoneField(form);
    }

    if (!response[0].ok || form.attr('name') === response[0].data.form_name) return;

    form.find('.appointment-content__call-code').removeClass('hidden');
    form.find('.input[name="code"]')
        .attr('required', 'required')
        .removeClass('js-form-check-required-ignore');
    form.find('.js-appointment-send-code')
        .attr('hidden', 'hidden')
        .attr('disabled', 'disabled');
    form.find('.js-appointment-confirm-code')
        .addClass('btn--disable')
        .removeAttr('hidden')
        .attr('disabled', 'disabled');
    form.find('.input[name="appointment_id"]')
        .attr('required', 'required')
        .removeClass('js-form-check-required-ignore')
        .val(response[0].data.appointment_id);
    makeReadonlyPhoneField(form);

    const data = new FormData(form[0]);

    function makeReadonlyPhoneField(form) {
        form.find('.input[name="phone"]').attr('readonly', 'readonly');
    }

    function runTimer() {
        startTimer(response[0].data.sms_timeout, form.find('.js-timer-time-wrapper')[0], buttonRepeat[0], true);
    }

    function requestCallCode() {
        $.ajax({
            type: 'POST',
            url: '/zapisatsya_na_priem/send_code/',
            data: data,
            processData: false,
            contentType: false,
            success: function(res) {
                if (res[0].ok) {
                    runTimer();
                } else {
                    form[0].TurboForm.errors = res[0].errors;
                    form[0].TurboForm.showErrors();
                }
            }
        });
    }

    const buttonRepeat = form.find('.js-timer-button');

    buttonRepeat.on('click', requestCallCode);

    runTimer();

    const newFormName = response[0].data.form_name;

    form.attr('name', newFormName);

    initTurboForm($('.js-form[name="' + newFormName + '"]')[0]);
});
